module.exports = __webpack_public_path__ + "static/media/gender-specific-active.cee4fa94.svg";